export default {
//    websiteBack: 'http://46.4.202.171:3032',
    websiteBack: 'https://tafs.us/api',
};
